module.exports = __webpack_public_path__ + "img/7ne.65db3030.svg";